import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar, getDataModified} from '../../../../../util/functions'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {LaundryConfigDaysDto} from '../../../model'
import {laundryConfigDaysSchema} from '../../../schema/laundryConfigDays'
import {
  createLaundryConfigDays,
  deleteLaundryConfigDays,
  updateLaundryConfigDays,
} from '../../../services'
import {funcDelete} from '../../../util/function'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
const ConfigDaysPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [loading, setLoading] = useState(false)
  const methods = useForm<LaundryConfigDaysDto>({
    resolver: yupResolver(laundryConfigDaysSchema),
  })
  const {reset} = methods

  const handleDelete = async () => {
    await funcDelete(
      deleteLaundryConfigDays,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: LaundryConfigDaysDto) => {
    try {
      setLoading(true)
      data = getDataModified(data)
      data.valor = Number(data.valor)
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createLaundryConfigDays(data)
        : await updateLaundryConfigDays({
            ...data,
            id: currentTabItem.idToEdit,
            tipoHuespedId: data.tipoServicio === 'ROPA HUÉSPED' ? data.tipoHuespedId : '',
          })

      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE

        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-configuration-days-laundry',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.message, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-configuration-days-laundry'
          textComponentGo='form-configuration-days'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={25}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default ConfigDaysPageWrapper
